<div class="bar-chart" (window:resize)="onResize($event)" #chartCtn id="chartCtn">
  <canvas id="myBarChart"></canvas>
</div>
